<template>
  <v-container fluid fill-height>
    <v-flex sm12>
      <v-toolbar
        color="#eee"
        class="elevation-0 secondary--text mb-4"
        style="background: transparent"
      >
        <v-layout row wrap justify-center class="mt-2">
          <v-flex xs6>
            <v-toolbar-title>Vouchers lidos</v-toolbar-title>
          </v-flex>
          <v-flex xs4>
            <v-select
              :items="[
                {text: 'Todos', value: null},
                {text: 'Clientes', value: false},
                {text: 'Empresas', value: true}
              ]"
              label="filtrar por"
              v-model="filtro"
            />
          </v-flex>
          <v-flex xs2>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn icon flat v-on="on" @click="dialogHistoricoCaixa = true">
                  <v-icon color="primary">assignment</v-icon>
                </v-btn>
              </template>
              Histórico do caixa
            </v-tooltip>
          </v-flex>
          <v-flex xs12>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              lazy
              transition="slide-y-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-btn flat small v-on="on" block color="primary">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <h2
                        v-on="on"
                        class="headline font-weight-medium"
                        style="width: 100%;"
                      >
                        {{mes}} de {{ picker ? picker.split('-')[0] : '' }}
                    </h2>
                    </template>
                    <h3>Clique para trocar o mês</h3>
                  </v-tooltip>
                </v-btn>
              </template>
              <v-date-picker v-model="picker" type="month" locale="pt-br" color="info" style="height: 33em;"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <div>
        <v-layout
          row
          wrap
          justify-space-between
          v-if="historyVouchers && historyVouchers.results.length > 0"
        >
          <v-flex
            v-for="(voucher, index) in historyVouchers.results"
            :key="index"
            md5
            xs12
          >
            <template>
              <v-menu
                offset-x
                :key="voucher.numero"
                left
                transition="slide-x-reverse-transition"
              >
                <template v-slot:activator="{ on }">
                  <card-compra
                    :key="index"
                    v-on="on"
                    :footer="true"
                    :on="on"
                    :cor="voucher.combustivel ? voucher.combustivel.color : 'info'"
                    :abastecido="voucher.abastecido"
                    :cupom_inserido="voucher.cupom_inserido"
                  >
                    <template v-slot:icone>
                      <v-tooltip
                        :color="voucher.combustivel ? voucher.combustivel.color : 'info'"
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <span v-on="on">
                            <svg-filler
                              :path="
                                voucher.combustivel && voucher.combustivel.icone
                                ? require(`@/assets/combs/${voucher.combustivel.icone}.svg`)
                                : require(`@/assets/combs/gas.svg`)
                              "
                              width="40px"
                              height="40px"
                              :fill="voucher.combustivel ? voucher.combustivel.color : 'info'"
                            />
                          </span>
                        </template>
                        <span>{{ voucher.combustivel ? voucher.combustivel.nome : 'Combustível não informado' }}</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:principal>
                      <h4>
                        {{ voucher.empresa ? 'Valor a pagar:' : 'Valor a abastecer:' }}
                        <span v-if="voucher.valor_total">{{voucher.valor_total | currency({ fractionCount: 2 })}}</span>
                      </h4>
                      <h4>
                        desconto total: <span v-if="voucher.valor_total && voucher.valor">{{ (voucher.valor_total - voucher.valor) | currency({ fractionCount: 2 }) }}</span>
                      </h4>
                      <h5 v-if="voucher" class="grey--text text--darken-3 caption font-weight-medium">
                        Valor pago: <span v-if="voucher.valor">{{ voucher.valor | currency({ fractionCount: 2 }) }}</span>
                      </h5>
                      <h5
                        class="grey--text text--darken-3 caption font-weight-medium"
                        v-if="voucher.desconto"
                      >
                        {{!voucher.proposta || voucher.tipo_proposta === 'presencial' ? 'Desconto' : ''}}: {{formatarDesconto(voucher.desconto)}}
                      </h5>
                      <h5 class="grey--text text--darken-3 caption font-weight-medium">
                        Lido por:
                        <span style="color: green;" v-if="voucher.frentista">
                          {{
                            voucher.frentista.nome
                          }}
                        </span>
                      </h5>
                      <h5
                        class="grey--text text--darken-3 caption font-weight-medium"
                        v-if="voucher.nsu"
                      >
                        NSU: {{ voucher.nsu }}
                      </h5>
                      <h5 v-if="voucher.numero">
                        Código: {{ voucher.numero }}
                      </h5>
                    <h5>
                      Cupom fiscal:
                      <span
                        :style="{ color: voucher.abastecido ? 'green' : '#3b5998' }"
                        >{{
                          voucher.abastecido ? "Inserido" : "Pendente"
                        }}
                      </span>
                    </h5>
                    </template>
                    <template v-slot:dados_usuario>
                      <v-layout column align-center justify-center fill-height>
                        <v-tooltip top lazy>
                          <template v-slot:activator="{ on }">
                            <v-flex v-on="on" shrink>
                              <v-layout fill-height align-end>
                                <v-avatar size="45">
                                    <img
                                      v-if="voucher.cliente && voucher.cliente.url_imagem_perfil"
                                      :src="voucher.cliente.url_imagem_perfil"
                                    />
                                    <v-icon size="45" v-else-if="voucher.empresa">mdi-domain</v-icon>
                                    <v-icon size="45" v-else>face</v-icon>
                                  </v-avatar>
                              </v-layout>
                            </v-flex>
                          </template>
                          <span v-if="voucher.cliente">
                            {{ voucher.cliente.nome_completo }}
                          </span>
                          <span v-else-if="voucher.empresa">{{ voucher.empresa.nome_fantasia }}</span>
                        </v-tooltip>
                        <v-flex
                            v-if="voucher.cliente"
                            class="grey--text text--darken-4 caption font-weight-medium"
                            shrink
                          >
                            {{ voucher.cliente.nome_completo }}
                          </v-flex>
                          <v-flex
                            v-if="voucher.veiculo"
                            class="grey--text text--darken-4 caption font-weight-medium"
                            shrink
                          >
                          {{ voucher.veiculo.identificacao }}
                        </v-flex>
                        <v-flex
                          v-if="voucher.veiculo"
                          class="grey--text text--darken-4 caption font-weight-medium"
                          shrink
                        >
                          {{ voucher.veiculo.modelo_marca }}
                        </v-flex>
                        <v-flex
                          v-if="voucher.empresa"
                          class="grey--text text--darken-4 caption font-weight-medium"
                          shrink
                        >
                          {{ voucher.empresa.nome_fantasia }}
                        </v-flex>
                      </v-layout>
                    </template>
                    <template v-slot:footer>
                      <v-flex xs4 class="centro">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <b>
                                {{
                                  voucher.data_inativado ? voucher.data_inativado.split("-").reverse().join("/") : 'Error'
                                }}
                              </b>
                            </span>
                          </template>
                          <span>Data da Compra</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex xs4 class="centro">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <b>
                                {{
                                  voucher.codigo || 'NÃO POSSUI CÓDIGO'
                                }}
                              </b>
                            </span>
                          </template>
                          <span>Código da Compra</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex xs4 class="centro">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <b>
                                {{
                                  voucher.tipo_pagamento || 'Empresa'
                                }}
                              </b>
                            </span>
                          </template>
                          <span>Forma de Pagamento</span>
                        </v-tooltip>
                      </v-flex>
                    </template>
                  </card-compra>
                </template>
                <v-list>
                  <template v-if="!voucher.abastecido">
                    <v-list-tile ripple @click="vincularCupom(voucher)">
                      <v-list-tile-content>
                        <v-list-tile-title
                          class="text-xs-center body-2 success--text"
                          >INSERIR CUPOM FISCAL</v-list-tile-title
                        >
                      </v-list-tile-content>
                      <v-list-tile-avatar>
                        <v-icon color="success">done_all</v-icon>
                      </v-list-tile-avatar>
                    </v-list-tile>
                  </template>
                  <template v-else>
                    <v-list-tile ripple @click="editarCupom(voucher)">
                      <v-list-tile-content>
                        <v-list-tile-title
                          class="text-xs-center body-2 success--text"
                          >RESUBMETER CUPOM FISCAL</v-list-tile-title
                        >
                      </v-list-tile-content>
                      <v-list-tile-avatar>
                        <v-icon color="success">insert_drive_file</v-icon>
                      </v-list-tile-avatar>
                    </v-list-tile>
                    <v-list-tile ripple @click="cancelarAbastecimento(voucher)">
                      <v-list-tile-content>
                        <v-list-tile-title
                          class="text-xs-center body-2 error--text"
                          >CANCELAR ABASTECIMENTO</v-list-tile-title
                        >
                      </v-list-tile-content>
                      <v-list-tile-avatar>
                        <v-icon color="error">close</v-icon>
                      </v-list-tile-avatar>
                    </v-list-tile>
                  </template>
                  <v-list-tile ripple @click="copyNumero(voucher.codigo)">
                    <v-list-tile-content>
                      <v-list-tile-title
                        class="text-xs-center body-2 info--text"
                        >COPIAR CÓDIGO DA COMPRA</v-list-tile-title
                      >
                    </v-list-tile-content>
                    <v-list-tile-avatar>
                      <v-icon color="info">content_copy</v-icon>
                    </v-list-tile-avatar>
                  </v-list-tile>
                  <v-list-tile ripple @click="copyNumero(voucher.numero)">
                    <v-list-tile-content>
                      <v-list-tile-title
                        class="text-xs-center body-2 primary--text"
                        >COPIAR CÓDIGO DO VOUCHER
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-avatar>
                      <v-icon color="primary">content_copy</v-icon>
                    </v-list-tile-avatar>
                  </v-list-tile>
                  <v-list-tile v-if="voucher.nsu" ripple @click="copyNsu(voucher.nsu)">
                    <v-list-tile-content>
                      <v-list-tile-title
                        class="text-xs-center body-2 gray--text"
                        >COPIAR NSU
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-avatar>
                      <v-icon color="gray">content_copy</v-icon>
                    </v-list-tile-avatar>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </template>
          </v-flex>
        </v-layout>
        <h2 v-else class="text-xs-center primary--text">
          NÃO HÁ VOUCHERS LIDOS NESSE MÊS
        </h2>
        <div class="text-xs-center">
          <v-pagination
            v-model="pagination.page"
            :length="pages"
            circle
          ></v-pagination>
        </div>
        <v-dialog lazy width="550" v-model="dialogHistoricoCaixa">
          <historico-caixa :visible="dialogHistoricoCaixa"></historico-caixa>
        </v-dialog>
        <v-dialog
          lazy
          width="500"
          :fullscreen="$vuetify.breakpoint.xs"
          v-model="dialogVincularCupom"
        >
          <vincular-cupom
            @fechar="dialogVincularCupom = false"
            :voucher="voucher"
          ></vincular-cupom>
        </v-dialog>
        <v-dialog
          lazy
          width="500"
          :fullscreen="$vuetify.breakpoint.xs"
          v-model="dialogEditarCupom"
        >
          <editar-cupom
            @fechar="dialogEditarCupom = false"
            :voucher="voucher"
          ></editar-cupom>
        </v-dialog>
      </div>
    </v-flex>
  </v-container>
</template>

<script>

import HistoricoCaixa from '@/components/dialogs/DialogHistoricoCaixa'
import EditarCupom from '@/components/dialogs/EditarCupom'
import VincularCupom from '@/components/dialogs/VincularCupom'
import CardCompra from '@/components/CardCompra'

export default {
  props: ['history'],
  components: {
    HistoricoCaixa,
    EditarCupom,
    VincularCupom,
    CardCompra
  },
  data: () => ({
    pagination: {
      rowsPerPage: 6,
      page: 1
    },
    picker: null,
    filtro: null,
    menu: false,
    dialogVincularCupom: false,
    dialogEditarCupom: false,
    dialogHistoricoCaixa: false,
    voucher: null,
    texto: 'Copiar NSU',
    texto2: 'Copiar código',
    color: '',
    historyVoucher: false
  }),
  computed: {
    pages () {
      let count = this.historyVouchers.count
      if (this.pagination.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.pagination.rowsPerPage)
    },
    historyVouchers () {
      return this.$store.getters.historyVouchers
    },
    frentista () {
      return this.$store.getters.frentista
    },
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    posto () {
      return this.$store.getters.posto
    },
    mes () {
      const numeroDoMes = this.picker ? Number(this.picker.split('-')[1]) : 1
      switch (numeroDoMes) {
        case 1:
          return 'Janeiro'
        case 2:
          return 'Fevereiro'
        case 3:
          return 'Março'
        case 4:
          return 'Abril'
        case 5:
          return 'Maio'
        case 6:
          return 'Junho'
        case 7:
          return 'Julho'
        case 8:
          return 'Agosto'
        case 9:
          return 'Setembro'
        case 10:
          return 'Outubro'
        case 11:
          return 'Novembro'
        case 12:
          return 'Dezembro'
        default:
          return 'Mês inválido'
      }
    }
  },
  watch: {
    'pagination.page': {
      handler (val, oldval) {
        this.carregarHistoryVouchers()
      },
      deep: true
    },
    picker (val) {
      this.menu = false
      if (val) this.carregarHistoryVouchers()
    },
    history (val) {
      this.historyVoucher = val
      if (val) {
        this.carregarHistoryVouchers()
      } else {
        this.$store.dispatch('cleanHistory')
      }
    },
    filtro (val) {
      this.carregarHistoryVouchers()
    },
    frentista (val) {
      if (val) this.carregarHistoryVouchers()
    }
  },
  beforeMount () {
    if (!this.picker) {
      const dataAtual = new Date()
      const mes = dataAtual.getMonth() + 1
      const ano = dataAtual.getFullYear()
      const mesFormatado = mes.toString().padStart(2, '0')
      this.picker = `${ano}-${mesFormatado}`
    }
  },
  methods: {
    formatarDesconto (desconto) {
      if (!desconto) return '0%'
      else if (desconto % 1 !== 0) {
        return `R$ ${desconto.toFixed(2).replace('.', ',')}`
      }
      return `${desconto}%`
    },
    carregarHistoryVouchers () {
      const data = {
        page: this.pagination.page
      }
      if (this.picker) {
        const tempData = this.picker.split('-')
        data.mes = tempData[1]
        data.ano = tempData[0]
      }
      if (this.filtro) data.isEmpresa = this.filtro
      this.$store.dispatch('carregarHistoryVouchers', data)
    },
    copyNsu (nsu) {
      navigator.clipboard.writeText(nsu)
      this.texto = 'Copiado'
      this.color = 'green'
      let interval = setInterval(() => {
        this.texto = 'Copiar NSU'
        this.color = ''
        clearInterval(interval)
      }, 500)
    },
    copyNumero (numero) {
      navigator.clipboard.writeText(numero)
      alert('Copiado')
      this.texto2 = 'Copiado'
      this.color = 'green'
      let interval = setInterval(() => {
        this.texto2 = 'Copiar Código'
        this.color = ''
        clearInterval(interval)
      }, 500)
    },
    cancelarAbastecimento (voucher) {
      this.$store.dispatch('cancelarAbastecimentoVoucher', voucher).then(() => {
        voucher.abastecido = false
      })
    },
    editarCupom (voucher) {
      this.voucher = voucher
      this.dialogEditarCupom = true
    },
    vincularCupom (voucher) {
      this.voucher = voucher
      this.dialogVincularCupom = true
    }
  }
}
</script>

<style scoped>

.centro {
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
